export const questions: Array<[string, string]> = [
  [
    'Professional level?',
    'Mining engineers, geologists, metallurgical professionals, mineral technicians, battery materials specialists, project developers worldwide.',
  ],
  [
    'Content depth?',
    'From critical minerals fundamentals through advanced extraction, chemical processing, battery technologies, project economics, and global supply chains. Scales from foundational to professional expertise.',
  ],
  ['International?', 'Yes. Universal mineral technology and geology principles with guidance for regional mining codes and standards.'],
  ['Editable?', 'Yes. Professional-grade PDFs for reference and technical documentation.'],
  ['Currency?', 'USD. Auto-converts to your local currency.'],
  [
    'What makes it different?',
    'Complete system: 6 coherent volumes, 5 exclusive bonuses, 150 technical terms, extraction technology comparisons, 37 calculation examples, 12 industry scenarios, 50 global reference maps. Everything designed so you never struggle with technical understanding again.',
  ],
  ['Not satisfied?', '7-day refund. 100% money back, no questions.'],
];
